import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  UserEntersPhoneNumber,
  userEntersPhoneNumber
} from '../actions/Actions';
import { IState, IUserInfo } from '../CustomTypes';
import InputField from '../input-components/InputField';
import {
  validatePhoneNumber,
  validatePhoneNumberStartsCorrectly
} from '../validators';
import {classNames, FontSize, Margin, TextColor} from '@snoam/pinata';

const styleClass = {
  errorMessage: classNames(
    TextColor.TEXT_NEGATIVE,
    Margin.MT_2,
    FontSize.TEXT_SM
  )

}

export interface IActionProps {
  userEntersPhoneNumber: UserEntersPhoneNumber;
}

export interface IParamProps {
  initialFocus?: boolean;
  validationErrorMessage?: any;
  formSubmitted?: boolean;
}

export interface IStateProps {
  userInfo: IUserInfo;
}

export interface IProps extends IParamProps, IStateProps, IActionProps {}

export class MobileNumber extends React.Component<IProps, {error: boolean}> {

  public constructor(props) {
    super(props);
    this.state = {
      error: false
    }
  }

  public onChangeInput(e) {
    const value = e.currentTarget.value;
    const isError = validatePhoneNumberStartsCorrectly(value);
    this.setState({error: !isError});
    this.props.userEntersPhoneNumber(value);
  }

  public render() {
    const { phoneNumber } = this.props.userInfo;
    const { initialFocus, validationErrorMessage, formSubmitted } = this.props;

    return (
      <>
      <InputField
        label="Mobilnummer"
        value={phoneNumber}
        type={'tel'}
        onChange={(e) => this.onChangeInput(e)}
        initialFocus={initialFocus}
        validationErrorMessage={'Ugyldig telefonnummer'}
        validator={validatePhoneNumber}
        validatorWhileTyping={validatePhoneNumberStartsCorrectly}
        formSubmitted={formSubmitted}
      />
        {this.state.error && <p className={styleClass.errorMessage}>{validationErrorMessage}</p>}
      </>
    );
  }
}

export default connect(
  (state: IState) =>
    ({
      userInfo: state.userInfo
    } as IStateProps),
  dispatch =>
    bindActionCreators(
      {
        userEntersPhoneNumber
      },
      dispatch
    ) as IActionProps
)(MobileNumber);
